import { Environment } from '../app/types/environment';

export const environment: Environment = {
  production: import.meta.env.NG_APP_PRODUCTION,
  apiUrl: import.meta.env.NG_APP_API_URL,
  websocketUrl: import.meta.env.NG_APP_WEBSOCKET_URL,
  customsClearUrl: import.meta.env.NG_APP_CUSTOMS_CLEAR_URL,
  googleMapId: import.meta.env.NG_APP_GOOGLE_MAP_ID,
};
